import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";
import Buttons from "../../../components/ui/button/Buttons";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
  resourceName: '',
  resourcetype: null,
  resourceTopicId: null,
  displayFeatureImage: null,
  format: null,
  speaker: '',
  displaySpeakerImage:null,
  publishDate:'',
  publishTime:'',
  unPublishDate:'',
  unPublishTime:''
};

export const CreateResourcesData = {
  name: "CreateResourcesData",
  initialState: initState,
  section: [
    {
      title: "Create Resources Data",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card d-unset row col-8",
      },
      //wrapperTemplate: <TitleWrapper title="" />
      fields: [
        {
          id: "resourceName",
          label: "Resource Name",
          Field_Name: "Resource Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "resourceName",
          fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
            textareaRows: 4,
          },
           validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-10 col-md-10 validation-left-0 mb-3",
          },
        },
        {
          id: "resourcetype",
          label: "Resource Type",
          Field_Name: "Resource Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "resourceType",
          fieldSetting: {
            placeholder: "Select",
            options: [

            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-10 col-md-10 validation-left-0 mb-3",
          },
        },
        {
          id: "resourceTopicId",
          label: "Topics",
          Field_Name: "Topics",
          fieldType: FormFieldTypes.SELECT,
          dataField: "resourceTopicId",
          fieldSetting: {
              placeholder: "Select resource topic",
              isMultiSelect: true,
              allowSpace: true,
              options: [
          
              ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
              containerCss: "col-lg-10 col-md-10 validation-left-0 mb-3",
          },
      },
      ],
    },
    {
      title: "Create Resources Data",
      row: {},
      style: {
        sectionStyle: "verticle-form d-unset mb-3 form-card row col-4 mt-4",
      },
      wrapperTemplate: <TitleWrapper title="" />,
      fields: [
        {
          id: "displayFeatureImage",
          label: "Upload Feature Image (please upload in jpg/png format max 2mb)",
          Field_Name: "Upload Feature Image",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "displayFeatureImage",
          fieldSetting: {
            placeholder: "Display Image",
            allowMultipleFiles: false,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.BMP,
              ImageFormats.JPG,
              ImageFormats.PNG,
              ImageFormats.WEBP,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 validation-text-fileuploader",
          },
        },
      ],
    },
    {
       title: "Create Resources Data",
      row: {},
      style: {
        sectionStyle: "mb-3 form-card row  mt-0",
      },
      wrapperTemplate: <TitleWrapper title="" />,
      fields: [
        {
          id: "format",
          label: "Format",
          Field_Name: "Format",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "format",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "page", label: "Page" },
              { value: "video", label: "Video" },
              { value: "report", label: "Report" },
              { value: "redirectTo", label: "Redirect to" },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 radioStyle col-md-4 ",
          },
        },
        {
          id: "speaker",
          label: "Speaker",
          Field_Name: "Speaker",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "speaker",
          fieldSetting: {
            allowSpace: true,
          },
         // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-xxl-8 col-xl-8 col-md-8 col-8 mt-4",
          },
        },
        {
          id: "displaySpeakerImage",
          label: "Upload Speaker Image",
          Field_Name: "Upload Speaker Image",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "displaySpeakerImage",
          fieldSetting: {
            placeholder: "Display Image",
            allowMultipleFiles: false,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.BMP,
              ImageFormats.JPG,
              ImageFormats.PNG,
              ImageFormats.WEBP,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
         // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-text-fileuploader mt-4",
          },
        },
        // {
        //   id: "",
        //   Field_Name: "",
        //   fieldType: FormFieldTypes.DATEPICKER,
        //   label: "",
        //   dataField: "",
        //   fieldSetting: {
        //     allowSpace: true,
        //     isDisable: false,
        //     isFormControl: true,
        //     isTemplateBtnDisable: false,
        //     formControltemplate: (
        //       <Buttons
        //         actionName={"Add_Discription"}
        //         buttonText={"Add Discription"}
        //         buttonTypeClassName="theme-btn left-side-form-btn"
        //         isTextWithIcon={false}
        //       // btnIcon={AppIcons.plusIcon} 
        //       />
        //     ),
        //   },
        //   style: {
        //     containerCss: "col-lg-12 col-md-3 mb-4 blank-field blank-field-with-btn left-side-btn",
        //   },
        // },
        {
          id: "publishDate",
          label: "Publish Date",
          Field_Name: "Publish Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "publishDate",
          fieldSetting: {
            placeholder: "dd-mm-yyyy",
            dateConfig: {
              maxDate: new Date(),
            },
          },

          style: {
            containerCss: "col-lg-4 col-md-6 validation-left-0 ",
          },
        },
        {
          id: "publishTime",
          label: "Publish Time",
          Field_Name: "Publish Time",
          fieldType: FormFieldTypes.TIMEPICKER,
         dataField: "publishTime",
          fieldSetting: {
            allowSpace: true,
            placeholder: "Select",
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0",
          },
        },
        {
          id: "unPublishDate",
          label: "Unpublish Date",
          Field_Name: "Unpublish Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "unPublishDate",
          fieldSetting: {
            placeholder: "dd-mm-yyyy",
            dateConfig: {
              maxDate: new Date(),
            },
          },
          style: {
            containerCss: "col-lg-4 col-md-6 validation-left-0 ",
          },
        },
        {
          id: "unPublishTime",
          label: "Unpublish Time",
          Field_Name: "Unpublish Time",
          fieldType: FormFieldTypes.TIMEPICKER,
          dataField: "unPublishTime",
          fieldSetting: {
            allowSpace: true,
            placeholder: "Select",
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },
        },
      ],
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
